const NON_EMERGENCY_ESCALATION_RE =
  /\b(?:dispatch|send|deploy|request|call)\b.{0,80}\b(?:patrol|unit|officer|police|responder|someone)\b/i;
const NON_EMERGENCY_BRING_RE =
  /\b(?:bring|get)\b.{0,80}\b(?:patrol|unit|officer|responder|someone)\b/i;
const NON_EMERGENCY_SCENE_RE =
  /\b(?:patrol|unit|officer|police|responder)\b.{0,80}\b(?:out there|come out|coming out|to the scene|on the way|respond|responding|sent)\b/i;
const NON_EMERGENCY_NEED_RE =
  /\b(?:have|need|want)\b.{0,80}\b(?:officer|unit|police)\b.{0,80}\b(?:out there|come out|to the scene|respond)\b/i;

const SPOKEN_ACTION_LABEL_RE =
  /^\s*(?:[-*]\s*)?(?:question|suggestion|task|conflicting_statement|conflicting statement)\s*:\s*/i;

export const NON_EMERGENCY_ESCALATION_REPLACEMENT = 'What else can you tell me for the report?';

export function isNonEmergencyEscalationText(text: string): boolean {
  const normalized = text || '';
  return (
    NON_EMERGENCY_ESCALATION_RE.test(normalized) ||
    NON_EMERGENCY_BRING_RE.test(normalized) ||
    NON_EMERGENCY_SCENE_RE.test(normalized) ||
    NON_EMERGENCY_NEED_RE.test(normalized)
  );
}

/**
 * Structural normalization only. The workflow and decision model own question
 * boundaries; truncating prose here removed "and last name" from an intact
 * workflow question. Keep the legacy export while preserving every clause.
 */
export function limitToSingleSpokenQuestion(text: string): string {
  return (text || '').replace(SPOKEN_ACTION_LABEL_RE, '').replace(/\s+/g, ' ').trim();
}

export function sanitizeOfficerSpeechText(text: string): string {
  const singleQuestion = limitToSingleSpokenQuestion(text);
  if (isNonEmergencyEscalationText(singleQuestion)) {
    return NON_EMERGENCY_ESCALATION_REPLACEMENT;
  }
  return singleQuestion;
}
